// garuda - Page Navigation Component

import React from "react";
import { useNavigation } from "../context/NavigationContext";
import ReadingModeToggle from "./ReadingModeToggle";
import "./PageNavigation.css";

const PageNavigation = ({
  isReadingMode,
  onToggleReadingMode,
  showReadingMode = false,
}) => {
  const { goBack, resetToHome, navigationHistory } = useNavigation();

  const canGoBack = navigationHistory.length > 1;

  return (
    <div className="page-navigation">
      <div className="nav-left">
        {canGoBack && (
          <button className="nav-button" onClick={goBack} title="Go Back">
            ← Back
          </button>
        )}
      </div>

      <div className="nav-center">
        {showReadingMode && (
          <ReadingModeToggle
            isReadingMode={isReadingMode}
            onToggle={onToggleReadingMode}
          />
        )}
      </div>

      <div className="nav-right">
        <button className="nav-button" onClick={resetToHome} title="Go Home">
          Home
        </button>
      </div>
    </div>
  );
};

export default PageNavigation;
